import React, { PureComponent } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { OAuthLogins, PwdLogin, Processing, clearShowLoginSnackbar } from 'cloak-file-sdk-web'
import CloakSnackBar from '../components/ui/CloakSnackBar'
import { SHOW_ENTERPRISE_LOGIN } from '../config'

import { styled } from '@mui/system';
import { modalStyles } from '../styles/styles'

const modalStyle = modalStyles.singleLineModal

const StyledLink = styled('a')({
    color: '#1aa3ff',
    textDecoration: 'underline',
    transition: 'color 0.2s ease',
    '&:hover': {
        color: '#1792e5',
        '@media (hover: none)': {
            color: '#1792e5',
        },
    },
});

const StyledLink2 = styled('a')({
    color: '#606060',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    '&:hover': {
        color: '#000000',
        '@media (hover: none)': {
            color: '#606060',
        },
    },
});


class LoginPage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            emailError: false,
            passError: false
        }

        this.closeSnackBar = this.closeSnackBar.bind(this)
    }

    closeSnackBar() {
        this.props.dispatch(clearShowLoginSnackbar())
    }

    componentDidMount() {
        console.log("In loginPage componentDidMount")
    }

    render() {
        const { intl } = this.props
        const { verifiedUser, authInProgress, token, info, showLoginSnackBar } = this.props;

        var surveyLink = "https://www.surveymonkey.com/r/3X7HFPQ"

        var url = new URL(window.location.href)
        console.log("url " + url)
        var email = url.searchParams.get("email")
        console.log("email " + email)
        var error = url.searchParams.get("error")
        console.log("error " + error)
        if (error === '0') {
            error = 'emailVerified'
        } else if (error === '1') {
            error = 'emailNotVerified'
        }

        if (token) {
            //alert("Token found, token: " + token); 
            //console.log("In render of LoginPage, token found. token %o", token)
            console.log("info %o", info)
            if (Object.values(info).length > 0) {

                if (info.mode === 'uncloak') {
                    return <Navigate to="/cloak/uncloak" />
                }
            }

            return <Navigate to="/cloak/cloak" />
        }

        if (verifiedUser === false) {
            return <Navigate to="/cloak/verify-email" />
        }

        // One-time post-logout redirect: a gateway/OTP user who just signed out should land on the
        // cloak QR page, not the password login. The logout saga sets this flag. Bounce before
        // rendering PwdLogin so no email is pre-filled and there's no flash of the password form.
        const gwLogoutFlag = window.localStorage.getItem('clk_post_logout_gateway')
        console.log("[gwy-logout] LoginPage clk_post_logout_gateway =", gwLogoutFlag)
        if (gwLogoutFlag === 'true') {
            window.localStorage.removeItem('clk_post_logout_gateway')
            console.log("[gwy-logout] LoginPage redirecting to /cloak/qr")
            return <Navigate to="/cloak/qr" />
        }

        return (
            <div className="clk-primary-console-div">
                {
                    showLoginSnackBar &&
                    <CloakSnackBar>
                        <div id="link-container">
                            <span id="spacer"></span>
                            <StyledLink href={surveyLink} target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="cloak.appSurvey" />
                            </StyledLink>
                            <span id="spacer"></span>
                            <StyledLink2 href="#" onClick={this.closeSnackBar}>x</StyledLink2>
                        </div>
                    </CloakSnackBar>
                }
                <div className="clk-primary-console clk-box-shadow ">
                    <div className="clk-login-div">
                        <Processing show={authInProgress} processing={authInProgress} style={modalStyle} message='login.loginInProgress' />
                        <div className="clk-main-title-div">
                            <div className="clk-main-title-text">
                                <FormattedMessage id="login.title" />
                            </div>
                        </div>
                        <PwdLogin emailLabel={intl.formatMessage({ id: 'login.email' })}
                            pwdLabel={intl.formatMessage({ id: 'login.password' })}
                            actionTitle={intl.formatMessage({ id: 'login.title' })}
                            email={email}
                            error={error} />

                        <br />
                        <div style={{ fontSize: 10, textAlign: 'center', color: '#a6a6a6', marginTop: 0 }}>
                            <NavLink to="/cloak/forgot-password" style={{ color: '#000' }}>
                                <FormattedMessage id="login.forgotPassword" />
                            </NavLink>
                        </div>
                        <div style={{ fontSize: 10, textAlign: 'center', color: '#a6a6a6', marginTop: 65 }}>
                            <FormattedMessage id="login.oauth" />
                        </div>
                        <OAuthLogins />
                        {SHOW_ENTERPRISE_LOGIN &&
                            <div style={{ fontSize: 10, textAlign: 'center', color: '#a6a6a6', marginTop: 12 }}>
                                <NavLink to="/cloak/enterprise-login" style={{ color: '#a6a6a6' }}>
                                    <FormattedMessage id="login.enterpriseLogin" />
                                </NavLink>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        authInProgress: state.auth.authInProgress,
        verifiedUser: state.auth.verifiedUser,
        token: state.auth.token,
        info: state.cloak.info,
        showLoginSnackBar: state.auth.showLoginSnackBar,
    }
};

export default connect(mapStateToProps)(injectIntl(LoginPage));
